import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children, className = '' }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleSidebarToggle = (collapsed) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <div className={`min-h-screen bg-background ${className}`}>
      {/* Sidebar */}
      <Sidebar onToggle={handleSidebarToggle} />
      
      {/* Header */}
      <Header sidebarCollapsed={sidebarCollapsed} />
      
      {/* Main Content */}
      <main 
        className={`transition-all duration-300 pt-16 ${
          sidebarCollapsed ? 'ml-16' : 'ml-64'
        }`}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;